import React, { ReactElement } from 'react';
import { accentGreen, regularWhite } from '../design-tokens';
import { StyledSvg } from './PlayLogo.styles';

export const PlayLogo = ({ className }: { className?: string }): ReactElement => (
    <StyledSvg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 722.63 292.2">
        <title>SVT Play logotyp</title>
        <g id="svt_play">
            <polyline
                fill={accentGreen}
                id="play"
                points="563.77 63.83 563.77 288.56 722.63 176.19 563.77 63.83"
            />
            <g id="svt" fill={regularWhite}>
                <path
                    id="t"
                    d="M478.89,292.35c-26.7,0-57.73-14.37-70.87-50.75-4.48-12.39-4.33-21.94-4.36-32V.15h45v64.5h69L501.3,108.58H448.63V209.65c0,7,.36,15.5,3.46,22,5.14,10.71,15.64,17.8,26.8,17.8,7.95,0,16.65-3.31,23.53-8.9l28.11,32.12A77.8,77.8,0,0,1,478.89,292.35Z"
                    transform="translate(-3.69 -0.15)"
                />
                <polygon
                    id="v"
                    points="328.99 64.5 269.92 222.88 210.85 64.5 162.65 64.5 245.82 287.5 294.02 287.5 377.19 64.5 328.99 64.5"
                />
                <path
                    id="s"
                    d="M84.69,292.16c-34.79,0-64-18.24-81-42.54l35.2-25.5c13.66,16.8,29.43,26,44.5,26,18.06,0,33.25-9.21,33.25-24.88,0-16.4-18.6-23.89-29.17-28.4-9.1-3.9-13.61-5.78-23.86-10.18-31.74-13.6-47.94-34.88-47.94-62.86,0-40.55,33.31-63.35,68.9-63.35,27.35,0,52.89,12.87,67,33.67L118.13,118.4c-10.06-10.75-20.57-16-32.11-16-13.56,0-25.65,7.63-25.65,21.62,0,10.47,8.69,19.24,26.59,26.8,3.58,1.51,22.22,9.79,26.74,11.86,32.32,14.82,48,35.07,48,61.9C161.73,265.47,127.93,292.16,84.69,292.16Z"
                    transform="translate(-3.69 -0.15)"
                />
            </g>
        </g>
    </StyledSvg>
);

export default PlayLogo;
